var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.00001,
    cy: 9.43757,
    rx: 5.78571,
    ry: 5.78571,
    fill: "#48BB78"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.26727,
    cy: 8.49992,
    r: 6.5,
    transform: "rotate(-56 9.26727 8.49992)",
    fill: "#48BB78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.549777 8.65212C0.465719 3.83645 4.29936 -0.133408 9.11504 -0.217466C13.9307 -0.301524 17.9006 3.53212 17.9846 8.34779C18.0687 13.1635 14.235 17.1333 9.41936 17.2174C4.60369 17.3014 0.633835 13.4678 0.549777 8.65212ZM5.61518 9.57987L8.11378 6.88156L8.22582 13.3001C8.23398 13.7676 8.61666 14.1372 9.08416 14.129L9.64658 14.1192C10.1141 14.111 10.4836 13.7284 10.4755 13.2608L10.3634 6.84229L12.9547 9.45176C13.2875 9.78702 13.8325 9.78454 14.1606 9.44478L14.537 9.05143C14.8617 8.71524 14.8523 8.18095 14.5162 7.85981L9.77377 3.27665C9.43759 2.952 8.90329 2.96132 8.58216 3.29745L3.99905 8.04339C3.6744 8.37958 3.68373 8.91387 4.01985 9.23501L4.40975 9.61498C4.74951 9.94308 5.29423 9.92654 5.61518 9.57987Z",
    fill: "#C6F6D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.9e237d3f0aff5f7e75e16f7504324179.svg";
export { ForwardRef as ReactComponent };